export const VIRALITY_COLORS = ["#634FE8", "#03BFC8", "#E22FC3"];

export const GRAPH_COLORS = [
  ...VIRALITY_COLORS,
  "#F9B300",
  "#F95607",
  "#007EDD",
  "#22C55E",
  "#FF800B",
  "#FB3231",
  "#EA2C7A"
];
